<template>
	<Button @click="onClick" type="danger" :size="size" :disabled="disabled">
		<template #icon>
			<IconCancel :size="size" style="margin-right: 4px" />
		</template>
		<slot />
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconCancel from '../icon/IconCancel.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconCancel
	}
}
</script>
